import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import useRequest from '../client/useRequest';

type FetchTeamsForFilter = {
  broad_search?: string;
  kind?: string;
  limit?: string;
  offset?: string;
};

type UseTeamsForFilters = (queryData: FetchTeamsForFilter) => RequestResponse<'teams.list'>;

const useTeamsForFilters: UseTeamsForFilters = (queryData: FetchTeamsForFilter) => {
  const params: RequestParamsType = {
    queryParams: { ...queryData, include_count: true },
  };

  const result = useRequest('teams.list', params, {
    // Need this so UI doesn't flicker. As when the filter changes, the query does too.
    keepPreviousData: true,
  });

  return result;
};

export default useTeamsForFilters;
